import { StyledPageSizeSelector } from './style';
import { Select, SelectOption } from '../Select';
import { useIntl } from 'react-intl';
import React from 'react';
import { DEFAULT_PAGE_SIZE } from 'utils/listPagination';

export interface Props {
  page_size_options: number[];
  setPageSize: (size: number) => void;
  value?: number;
}

export const PageSizeSelector = ({
  page_size_options,
  setPageSize,
  value,
}: Props) => {
  const intl = useIntl();

  return (
    <StyledPageSizeSelector>
      <div className={'text'}>
        {`${intl.formatMessage({ id: 'top_filter.per_page' })}: `}
      </div>
      <div className={'icon'}>
        <Select
          showSearch={false}
          variant={'borderless'}
          value={value}
          defaultValue={DEFAULT_PAGE_SIZE}
          onChange={(newPageSize: number) => setPageSize(newPageSize)}
          dropdownStyle={{
            minWidth: '150px',
          }}
        >
          {page_size_options.map((opt: number) => (
            <SelectOption value={opt} key={opt}>
              {opt}
            </SelectOption>
          ))}
        </Select>
      </div>
    </StyledPageSizeSelector>
  );
};
